<template>
    <div class="app-badge">
        <slot/>
        <sup
            v-show="!hidden && isDot"
            :class="[
                'app-badge__content--' + type
            ]"
            class="app-badge__content"/>
    </div>
</template>

<script>
export default {
    name: 'app-badge',
    props: {
        isDot: Boolean,
        hidden: Boolean,
        type: {
            type: String,
            validator(val) {
                return (['default', 'success', 'info'].indexOf(val) > -1)
            }
        }
    }
}
</script>

<style lang="stylus">
    @import "../../stylus/variables"
    .app-badge
        position: relative;
        vertical-align: middle;
        display: inline-block;
        
    .app-badge__content
        background-color: $red
        position: absolute
        -webkit-transform: translateY(-50%) translateX(100%)
        transform: translateY(-50%) translateX(100%)
        border: 1px solid #FFF
        height: 12px
        width: 12px
        padding: 0
        right: 8px
        top: 2px
        border-radius: 50%

    .app-badge__content--default
        background-color: $red
    .app-badge__content--success
        background-color: $green
    .app-badge__content--info
        background-color: $medium-blue
</style>